// components/chat/FileAttachmentPanel.js
import React from 'react';
import './FileAttachmentPanel.css';

const FileAttachmentPanel = ({ 
  attachedFiles, 
  keepFiles, 
  handleRemoveFile, 
  handleClearAllFiles, 
  handleKeepFilesToggle 
}) => {
  return (
    <div className="attached-files-container">
      <div className="attached-files-header">
        <h4>Attached Files</h4>
        <button 
          className="clear-files-button" 
          onClick={handleClearAllFiles}
          title="Clear all files"
        >
          Clear All
        </button>
      </div>
      <div className="attached-files-list">
        {attachedFiles.map((file, index) => (
          <div key={index} className="attached-file">
            <span className="file-name">{file.fileName}</span>
            <button 
              className="remove-file-button" 
              onClick={() => handleRemoveFile(index)}
              title="Remove file"
            >
              ×
            </button>
          </div>
        ))}
      </div>
      <div className="keep-files-toggle">
        <label className="toggle-label">
          <input 
            type="checkbox" 
            checked={keepFiles} 
            onChange={handleKeepFilesToggle} 
          />
          <span className="toggle-text">Keep files for next requests</span>
        </label>
      </div>
    </div>
  );
};

export default FileAttachmentPanel;